import styled from "@emotion/styled";

import { Flex } from "../../styles/utility-components";
import { blue600, blue700, green800, grey500, red500, red700, red800 } from "../themes/colors";

const DEFAULT_COLOR = grey500;
type FileExtension = "csv" | "doc" | "docx" | "pptx" | "xlsx" | "odt" | "odp" | "ods" | "pdf";

const fileExtensionColorMap: Record<FileExtension, string> = {
  csv: green800,
  xlsx: green800,
  ods: green800,
  doc: blue700,
  docx: blue700,
  pptx: red800,
  odt: blue600,
  odp: red700,
  pdf: red500,
};
type Props = {
  type: string;
};

export default function FileTypeIcon({ type }: Props) {
  const color =
    type in fileExtensionColorMap ? fileExtensionColorMap[type as FileExtension] : DEFAULT_COLOR;

  return (
    <Container backgroundColor={color}>
      <IconText>{type}</IconText>
    </Container>
  );
}

const Container = styled(Flex)<{ backgroundColor: string }>(({ backgroundColor }) => ({
  backgroundColor,
  width: 32,
  height: 32,
  padding: "8px 0",
  borderRadius: 4,
  justifyContent: "center",
  alignItems: "center",
}));

const IconText = styled.span(({ theme }) => ({
  color: theme.colors.sysTextWhite,
  fontWeight: 600,
  fontSize: 9.6,
  lineHeight: "16px",
  textTransform: "uppercase",
}));
